import React from 'react';
import { Link } from 'react-router-dom';

const Logout = () => (
  <div
    style={{
      height: '100vh',
      width: '100wv',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <h1>Вы не авторизованы</h1>
    <Link to="/" style={{ fontSize: '18px', marginTop: '20px' }}>
      Вернуться на сайт
    </Link>
  </div>
);

export default Logout;
